
var $body,
    $toggleMenu;


$(document).ready(function($) {

    console.log('%cLinku Novio',"font-size: 2em; font-family: sans-serif; color: white; background-color:#18aaff; padding:4px 8px; border-radius: 4px");

    $body = $('body');
    $toggleMenu = $("#toggleMenu");


    $toggleMenu.click(function(){
        $body.toggleClass('show-menu');
    })

});
